export const taxStatusLookup: Record<string, string> = {
  taxable: 'Taxable',
  'tax-deferred': 'Tax-deferred',
  'tax-exempt': 'Tax-exempt'
}
